import React from 'react';

import Loop from 'components/Loop';
import wfLoader from 'assets/lotties/wf-loader-black.json';

import { DefaultSection } from 'styles/default';
import { LoadingBoxWrapper } from 'apps/home/landing/sections/fullScreenLoading.styles';

const FullScreenLoading = () => (
  <DefaultSection fullScreen>
    <LoadingBoxWrapper>
      <Loop lottieFile={wfLoader} />
    </LoadingBoxWrapper>
  </DefaultSection>
);

export default FullScreenLoading;
